// ...
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { AuthService } from '../services/auth.service';
import { EraService } from '../services/era.service';
import { SsoService } from '../services/sso.service';

/**
 * Interceptor logs user out if api request returns status code 400 or 401.
 * If current request is /login request then the logout process is not
 * triggered. The login page handel the 400/401 errors.
 */
@Injectable()
export class UnathorizedInterceptor implements HttpInterceptor {
  private unauthorizedView = '/unauthorized';

  // NOTE: EraService must NOT be a constructor dependency here. EraService
  // injects HttpClient, and HttpClient constructs its DI interceptors —
  // injecting it eagerly creates the cycle HttpClient -> this interceptor ->
  // EraService -> HttpClient, which throws NG0200 on the app's very first
  // HTTP call (the translation loader at bootstrap) and leaves the whole app
  // as a blank page. Resolve it lazily via Injector at intercept time
  // instead — by then HttpClient already exists, so there is no cycle.
  constructor(
    private router: Router,
    private authService: AuthService,
    private injector: Injector
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            return;
          }
        },
        (err: any) => {
          if (
            request.url &&
            ((request.url.endsWith('/login') &&
              !request.url.endsWith('/era/login')) ||
              request.url.endsWith('/password/check'))
          ) {
            return;
          } else {
            if (err instanceof HttpErrorResponse) {
              if (err.status === 401 || err.status === 400) {
                // While an eRa login confirmation is in flight, the active
                // organization unit's session legitimately has no
                // eraSessionId yet, so the backend 401s any other
                // authenticated route the app happens to call in the
                // background (e.g. the settings bootstrap in AppComponent).
                // Don't tear down an otherwise valid session for that -
                // era-login.component handles its own success/failure
                // outcome once confirmLogin resolves. Same rationale for
                // SsoService while POST /oidc/token is in flight -
                // sso-login.component handles that outcome itself.
                if (
                  this.injector.get(EraService).isEraConfirmInProgress() ||
                  this.injector.get(SsoService).isSsoConfirmInProgress()
                ) {
                  return;
                }
                // Clear storage before redirect to prevent showing home page
                this.authService.clearSession();
                window.location.replace('/login');
              } else if (err.status === 403) {
                // this.router.navigate([this.unauthorizedView]);
              }
            }
          }
        }
      )
    );
  }
}
